import BankAccountRoutes from './BankAccount/routes'
import ContractRoutes from './Contract/routes'
import PartnerRoutes from './Partner/routes'
import FinanceTransactionRoutes from './FinanceTransaction/routes'
import FinanceCategories from './FinanceCategory/routes'
import PaymentMethods from './PaymentMethods/routes'
import CostCenters from './CostCenter/routes'
import Services from './Service/routes'
import Invoices from './Invoice/routes'

const FinanceIndex = () => import('./Index.vue')

export default [
  {
    name: 'finance',
    path: 'finance',
    component: FinanceIndex,
    children: [
      ...ContractRoutes,
      ...PartnerRoutes,
      ...BankAccountRoutes,
      ...FinanceTransactionRoutes,
      ...FinanceCategories,
      ...PaymentMethods,
      ...CostCenters,
      ...Services,
      ...Invoices
    ]
  }
]
